import {
  CallLogServiceClient,
  ListCallLogRequest,
  CallLog,
  CallNoticeRequest,
  Empty,
  GetAccountIdRequest,
  ListCallLogAuditRequest,
} from '../proto/marginpb/calllog_grpc_web_pb';
import { stringToProtoDate, objectToProtoDate } from './ConvertService';
import { notifyError } from '../components/Messages/Notification';
import { auth } from '../lib/auth/Auth';
import { Pagination } from '../proto/utilspb/pagination_pb';
import { lazySystemCode } from './CommonService';

const service = new CallLogServiceClient(window.env.GRPC_ENDPOINT, {}, { ...auth });

export async function listCallLog(param, paging) {
  let marginTypes = [];
  if (param.marginType?.length > 0 && !param.marginType[0].code) {
    const { systemCodeList } = await lazySystemCode({
      type: 'Margin Type',
    });

    // to get the code onload
    for (const r of param.marginType) {
      let code;
      const res = systemCodeList.find((v) => {
        return v.systemRef === r?.systemRef?.trim();
      });
      code = res?.code;
      marginTypes.push(code);
    }
  } else if (param.marginType?.length > 0 && param.marginType[0].code) {
    for (let i = 0; i < param.marginType?.length; i++) {
      marginTypes.push(param.marginType[i].code);
    }
  }
  return new Promise((resolve, reject) => {
    const callTypes = [];
    if (param.callType?.length > 0) {
      for (let i = 0; i < param.callType?.length; i++) {
        callTypes.push(param.callType[i].code);
      }
    }

    const marginType = "'" + marginTypes.join("','") + "'";
    const callType = "'" + callTypes.join("','") + "'";

    let req = new ListCallLogRequest();
    req.setToDate(stringToProtoDate(param.toDate));
    req.setFromDate(stringToProtoDate(param.fromDate));
    req.setCorrespondent(param.correspondent);
    req.setMasterAccountNo(param.masterAccountNo);
    req.setAccountName(param.accountName);
    req.setCallType(callType);
    req.setCallStatus(param.callStatus);
    req.setCallStatusReason(param.callStatusReason);
    req.setMarginType(marginType);
    req.setIsOpen(param.isOpen);

    if (paging) {
      let pg = new Pagination();
      pg.setPageNo(paging.pageNo);
      pg.setPageSize(paging.rowsPerPage);
      pg.setSortName(paging.sortName);
      pg.setSortDirection(paging.sortDirection);
      pg.setFilterNamesList(paging.filterNames);
      pg.setFilterValuesList(paging.filterValues);
      req.setPagination(pg);
    }

    service.listCallLog(req, {}, (error, response) => {
      if (error) {
        notifyError(error.message);
        reject(error);
      } else {
        resolve(response.toObject());
      }
    });
  });
}

export async function updateCallLog(param) {
  return new Promise((resolve, reject) => {
    const req = new CallLog();
    req.setRequirementLogId(param.requirementLogId);
    req.setCallStatus(param.callStatus);
    req.setCallStatusReason(param.callStatusReason);
    req.setTradeDate(stringToProtoDate(param.tradeDate));
    req.setDueDate(stringToProtoDate(param.dueDate));
    req.setCallAmt(param.callAmt);
    req.setSatisfiedDate(stringToProtoDate(param.satisfiedDate));
    service.updateCallLog(req, {}, (error, response) => {
      if (error) {
        notifyError(error.message);
        reject(error);
      } else {
        resolve(response.toObject());
      }
    });
  });
}

export async function callNotice(param) {
  return new Promise((resolve, reject) => {
    let req = new CallNoticeRequest();
    req.setAccountIdsList(param);

    service.callNotice(req, {}, (error, response) => {
      if (error) {
        reject(error);
      } else {
        resolve(response.toObject());
      }
    });
  });
}

export async function getNewId() {
  return new Promise((resolve, reject) => {
    let req = new Empty();

    service.getNewId(req, {}, (error, response) => {
      if (error) {
        reject(error);
      } else {
        resolve(response.toObject());
      }
    });
  });
}

export async function createCallLog(param) {
  return new Promise((resolve, reject) => {
    const req = new CallLog();
    req.setRequirementLogId(param.requirementLogId);
    req.setCorrespondent(param.correspondent);
    req.setMasterAccountNo(param.masterAccountNo);
    req.setMarginType(param.marginType);
    req.setCallType(param.callType);
    req.setAge(param.age);
    req.setCallStatus(param.callStatus);
    req.setCallStatusReason(param.callStatusReason);
    req.setTradeDate(stringToProtoDate(param.tradeDate));
    req.setDueDate(stringToProtoDate(param.dueDate));
    req.setCallReq(param.callReq);
    req.setCallAmt(param.callAmt);
    req.setOrigCallAmt(param.origCallAmt);
    req.setAccountId(param.accountId);
    req.setCallStatusReasonCount(param.callStatusReasonCount);
    service.createCallLog(req, {}, (error, response) => {
      if (error) {
        notifyError(error.message);
        reject(error);
      } else {
        resolve(response.toObject());
      }
    });
  });
}

export async function getAccountId(param) {
  return new Promise((resolve, reject) => {
    let req = new GetAccountIdRequest();
    req.setMasterAccountNo(param.masterAccountNo);
    req.setMarginType(param.marginType);

    service.getAccountId(req, {}, (error, response) => {
      if (error) {
        reject(error);
      } else {
        resolve(response.toObject());
      }
    });
  });
}

export async function listCallLogAudit(id) {
  return new Promise((resolve, reject) => {
    const req = new ListCallLogAuditRequest();
    req.setRequirementLogId(id);

    service.listCallLogAudit(req, {}, (error, response) => {
      if (error) {
        reject(error);
      } else {
        resolve(response.toObject());
      }
    });
  });
}
